const localization = {
    cannot_delete_default_language: '{{languageTag}} đang được đặt làm ngôn ngữ mặc định và không thể xóa.',
    invalid_translation_structure: 'Cấu trúc dữ liệu không hợp lệ. Vui lòng kiểm tra dữ liệu đầu vào và thử lại.',
};
export default Object.freeze(localization);
